import { useEffect, useState } from 'react';
import { hoy, type FechaLocal } from '@/domain/dates';

/**
 * La fecha local de hoy, que cambia sola al pasar la medianoche (Req. 24.4).
 *
 * iOS deja la app suspendida en memoria: al volver a abrirla puede ser otro
 * día sin que la página se haya recargado. Por eso se revisa cada minuto y
 * cada vez que la app vuelve a primer plano.
 */
export function useFechaHoy(): FechaLocal {
  const [fecha, setFecha] = useState<FechaLocal>(hoy);

  useEffect(() => {
    const revisar = () => setFecha((actual) => (hoy() === actual ? actual : hoy()));
    const intervalo = window.setInterval(revisar, 60_000);
    document.addEventListener('visibilitychange', revisar);
    window.addEventListener('focus', revisar);
    return () => {
      window.clearInterval(intervalo);
      document.removeEventListener('visibilitychange', revisar);
      window.removeEventListener('focus', revisar);
    };
  }, []);

  return fecha;
}
